/**
 * Канон query-фильтра расписания по тренеру: trainer_user_id.
 * trainer_id — alias один релиз (ADR-0026 §9).
 */
export function readScheduleTrainerUserIdQuery(searchParams: URLSearchParams): number | null {
  const raw = searchParams.get('trainer_user_id') ?? searchParams.get('trainer_id');
  if (raw == null || raw === '') {
    return null;
  }
  const n = Number.parseInt(raw, 10);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/** Если в URL только legacy trainer_id — заменить на trainer_user_id (replaceState). */
export function canonicalizeScheduleTrainerQuery(
  searchParams: URLSearchParams,
  setSearchParams: (next: URLSearchParams, opts?: { replace?: boolean }) => void
): void {
  const legacy = searchParams.get('trainer_id');
  const canonical = searchParams.get('trainer_user_id');
  if (!legacy || canonical) {
    return;
  }
  const next = new URLSearchParams(searchParams);
  next.set('trainer_user_id', legacy);
  next.delete('trainer_id');
  setSearchParams(next, { replace: true });
}
